<template>
  <multi-select
    v-model="selected"
    :identifier="identifier"
    :search="true"
    :options="options"
    :show-labels="false"
    :placeholder="placeholder"
    label="label"
    trackBy="value"
    @select="update"
    @remove="remove">
  </multi-select>
</template>

<script>
import MultiSelect from 'vue-multiselect'

export default {
  props: {
    identifier: {
      type: Number,
      default: null
    },
    value: {
      type: Number || String,
      default: null
    },
    options: {
      type: Array,
      required: true
    },
    placeholder: {
      type: String,
      default: null
    }
  },
  components: {
    MultiSelect
  },
  data () {
    return {
      selected: null
    }
  },
  created () {
    this.setSelected()
  },
  watch: {
    value () {
      this.setSelected()
    },
    selected () {
      const value = (this.selected) ? this.selected.value : null

      this.$emit('input', value)
    }
  },
  methods: {
    setSelected () {
      this.selected = (this.value !== null) ? this.options.find(option => option.value === this.value) : null
    },
    update (payload) {
      this.$emit('update', payload)
    },
    remove (payload) {
      this.$emit('remove', payload)
    }
  }
}
</script>

<style>
  .multiselect__option--highlight {
    background: hsl(171, 100%, 41%);
  }

  .multiselect__option--selected.multiselect__option--highlight {
    background: hsl(348, 100%, 61%);
  }

  #combinatorWrapper.has-fixed-height .multiselect__content-wrapper {
    min-height: 500px !important;
  }
</style>
